import { useQuery } from "@apollo/client/react";
import waitForQueries from "components/waitForQueries";
import NetworkStateContext from "contexts/NetworkStateContext";
import UIStateContext from "contexts/UIStateContext";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import { GetAllLines } from "hooks/apollo/line/line.gql";
import { GetTeardownTimes } from "hooks/apollo/teardownTime/teardownTime.gql";
import EventTypes from "hooks/apollo/usageData/EventTypes";
import useTrackUsage from "hooks/apollo/usageData/useTrackUsage";
import useSubscriptions from "hooks/apollo/useSubscriptions";
import useGetWorkOrders from "hooks/apollo/workOrder/useGetWorkOrders";
import useSlideOutState from "hooks/state/useSlideOutState";
import useComponentDidMount from "hooks/useComponentDidMount";
import { useContext } from "react";
import SchedulePageView from "./SchedulePageView";

export default function SchedulePageContainer() {
  const trackUsage = useTrackUsage();
  useComponentDidMount(() => trackUsage(EventTypes.VIEW_SCHEDULE_PAGE));

  useSubscriptions();

  const { isFetching } = useContext(NetworkStateContext);
  const fetching = isFetching("CLOSE_GAP") || isFetching("GET_BLOCKS") || isFetching("SPLIT_BLOCKS");

  const queries = [
    useApplicationContext(),
    useQuery(GetAllLines, { variables: { activeOnly: true } }),
    useQuery(GetTeardownTimes),
    useGetWorkOrders(),
  ];
  const {
    state: { sidebarOpen },
  } = useContext(UIStateContext);
  const { isOpen } = useSlideOutState();

  return waitForQueries({ queries })(SchedulePageView)({
    fetching,
    sidebarIsOpen: sidebarOpen,
    slideOutIsOpen: isOpen(),
  });
}
